import { post } from "@insite/client-framework/Services/ApiService";
import { UspsAddressValidationModel } from "@insite/client-framework/Types/ApiModels";

export function uspsAddressValidate(
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
) {
    const request = {
        Address1: address1,
        Address2: address2,
        City: city,
        State: state || "",
        PostalCode: postalCode,
    } as UspsAddressValidationModel;
    // const response = await post<UspsAddressValidationModel>("api/uspsvalidation", request);
    // return response;
    return null;
}
